export const AVATAR_LOCALSTORAGE_KEY = 'user-avatar'
export const DEFAULT_ENDPOINT = 'DEFAULT_ENDPOINT'
export const NOAUTH_ENDPOINT = 'NOAUTH_ENDPOINT'

export const AUTH_ENDPOINT = 'AUTH_ENDPOINT'
export const MOCKAPI_ENDPOINT = 'MOCKAPI_ENDPOINT'
export const VAULT_ENDPOINT = 'VAULT_ENDPOINT'
